exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test {\n  width: 7.5rem;\n  height: 100%;\n  font-size: 0.3rem;\n  line-height: 0.52rem;\n  padding-bottom: 2rem;\n}\n.test button {\n  font-size: 0.3rem;\n  padding: 0.2rem;\n  margin: 0.3rem;\n}\n.test img {\n  width: 100px;\n}\n.test table,\n.test td {\n  border: 1px solid #515151;\n}\n.test table img,\n.test td img {\n  width: 100px;\n}\n.img-night {\n  width: 3rem;\n  height: 3rem;\n  background-color: pink;\n  margin: 0 auto;\n  display: -ms-grid;\n  display: grid;\n  /* grid-template-columns: 1rem 1rem 1rem;\n  grid-template-rows: 1rem 1rem 1rem; */\n  /* grid-template-columns: repeat(3,33.33% 24% 44.66%); */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/test/webview/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/test/webview/index.less
// module chunks = 0